import React, { useEffect, useRef, useState } from "react";
import "../Message/Message.css";
import { Tab, Tabs } from "react-bootstrap";
import { avatar, img_placehlder, msg_list } from "../../../assets";
import { CiSearch } from "react-icons/ci";
import { socket } from "../../../utils/socket";
import moment from "moment";
import useDebounce from "../../../hooks/useDebounce";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCrossCircled } from "react-icons/rx";
import { useNavigate } from "react-router";

const ChatList = ({
  selectedChatType,
  setSelectedChatType,
  setSelectedChat,
  groupDetails,
  setGroupDetails,
  setMemberDetails,
  chatId,
  tab,
  onClick,

  setIsReplay,
  setSelectReplyData,

  chatType,
}) => {
  const [chatList, setChatList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastChatId, setLastChatId] = useState(null);
  const [search, setSearch] = useState({});
  const debouncedValue = useDebounce(search, 300);
  const sidebarListRef = useRef(null);
  const [totalPages, setTotalPages] = useState(null);
  const navigate = useNavigate()
  // console.log('selectedChatType', selectedChatType)
  // console.log('lastChatId', lastChatId)

  // const tabsName = chatType === 'GROUP' ? "Group Chat..." : chatType === 'MEMBER' ? 'Member Chat...' : 'chat'
  //   Receive Chat List
  const receiveChatList = (data) => {
    // console.log("receive Chat List", data);
    const { success, data: chat, meta } = data;
    if (success) {
      setChatList(chat || []);
      setTotalPages(meta?.totalPages);
      if (!chatId) {
        setSelectedChat(chat?.[0]?._chat);
        setLastChatId(chat?.[0]?._chat);
      }
      // scrollToBottom(meta?.page);
    }
  };
  //--------chaiId-find------------------
  useEffect(() => {
    if (chatId) {
      // console.log('chaiId-find', chatId)
      const findChatData = chatList.find((data) => data?._chat?._id === chatId);
      setSelectedChat(findChatData?._chat);
      setLastChatId(findChatData?._chat);
    }
  }, [chatList, chatId]);
  // Receive Chat List
  useEffect(() => {
    socket.on("RECEIVE_CHAT_LIST", receiveChatList);
    return () => {
      socket.off("RECEIVE_CHAT_LIST");
      setCurrentPage(1);
    };
  }, [chatId,]);

  useEffect(() => {
    socket.emit("REQUEST_CHAT_LIST", {
      page: 1 || currentPage,
      limit: 10000000,
      search: debouncedValue,
      type: chatType // selectedChatType,
    });

    if (!debouncedValue) {
      setMemberDetails('')
    }
  }, [chatType, debouncedValue]);//selectedChatType

  useEffect(() => {
    setSearch("");
    setCurrentPage(1);
    // if(chatId){

    // }
  }, [chatType]);//selectedChatType

  const handleExit = (item) => {
    socket.emit("REQUEST_LEAVE_ROOM", {
      _chat: lastChatId,
    });
    setLastChatId(item);
  };

  // const scrollToBottom = (page) => {
  //   const chatContainer = sidebarListRef.current;
  //   if (chatContainer) {
  //     const currentScrollHeight = chatContainer.scrollHeight;
  //     setTimeout(() => {
  //       if
  //         (page === 1) {
  //         // chatContainer.scrollBottom = 0;
  //         chatContainer.scrollTop =
  //           chatContainer.scrollHeight - currentScrollHeight;
  //       } else {
  //       }
  //       // chatContainer.scrollTop =
  //       //   chatContainer.scrollHeight - currentScrollHeight;
  //       chatContainer.scrollBottom = 0;

  //     }, 0);
  //   }
  // };

  //   Load More older message
  // const loadMoreMessages = () => {
  //   const chatContainer = sidebarListRef.current;
  //   if (chatContainer.scrollTop === 0 && totalPages > currentPage) {
  //     receiveChatList(currentPage + 1);
  //     setCurrentPage((prev) => prev + 1);
  //   }
  // };
  //-------reset-search-page-when-tab-change-----------

  //-------------handle-Member-Search---------------
  const handleMemberSearchData = (id, user) => {
    // console.log('user id', id)
    if (id) {
      setMemberDetails(user)
      socket.emit('REQUEST_USER_DETAIL', {
        _user: id
      })
    }
  }

  useEffect(() => {
    socket.on("RECEIVE_USER_DETAIL", receiveSearchMemberData);
    return () => {
      socket.off("RECEIVE_USER_DETAIL");
      setCurrentPage(1);
    };
  }, []);

  const receiveSearchMemberData = (data) => {
    if (data?.success) {
      // console.log("receiveSearchMemberData true", data);
      // setChatList(data?.data?._chat || []);
      // setTotalPages(meta?.totalPages);
      // if (!chatId) {
      setSelectedChat({ ...data?.data?._chat, chatExist: true });
      // setLastChatId(data?.data?._chat);
      // }
    } else {
      // console.log('receiveSearchMemberData false', data)
      setSelectedChat(data?.data);
    }
  }

  // useEffect
  return (
    // <div className="msg_list_sidebar " >
    <div className="msg_list_sidebar">
      <button className="crossbtn" onClick={onClick}>
        <RxCrossCircled />
      </button>

      {/* <Tabs
        defaultActiveKey={selectedChatType}
        defaultActiveKey={chatType}
        id="uncontrolled-tab-example"
        className="mb-2 mt-2"
        onClick={() => {
          if (chatId) {
            navigate('/dashboard/message');
          }
          setIsReplay(false)
          setSelectReplyData({})
        }}
        onSelect={(e) => {
          setSelectedChatType(e);
          socket.emit("REQUEST_LEAVE_ROOM", {
            _chat: lastChatId,
          });
        }}
      >
        <Tab eventKey={chatType} title={tabsName}></Tab>
        <Tab eventKey="GROUP" title="Group Chats"></Tab>
        <Tab eventKey="MEMBER" title="Member Chats"></Tab>
      </Tabs> */}

      <div className="msg_list_search-bar">
        <input
          type="text"
          className="msg-search-input"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search here"
        />
        <CiSearch className="search_icon" />
      </div>
      {/* <div className="msg-chat-list"> */}
      <div
        className="msg-chat-list"
      // ref={sidebarListRef}
      // onScroll={loadMoreMessages}
      >
        {/* Group Chat List */}
        {/* {selectedChatType === "GROUP" && */}
        {chatType === "GROUP" &&
          chatList &&
          chatList?.map((data, ind) => (
            <div
              key={ind}
              className="chat-item"
              onClick={() => {
                setSelectedChat(data?._chat);
                handleExit(data?._chat);
                setIsReplay(false)
                setSelectReplyData({})
                if (chatId) {
                  // navigate(`/dashboard/message`);
                  navigate('/dashboard/message/group')
                }
              }}
            >
              <div className="chat-avatar">
                <img
                  src={data?._chat?._group?.coverImage || avatar}
                  alt="Mindful Movers"
                />
              </div>

              <div className="chat-details">
                <p className="chat-title">
                  {data?._chat?._group?.name || ''}
                </p>
                {data?._chat?.lastMessage?._sender?.fullName && (
                  <p className="chat-subtitle">
                    {data?._chat?.lastMessage?._sender?.fullName} :{" "}
                    {data?._chat?.lastMessage?.type === "TEXT"
                      ? (data?._chat?.lastMessage?.message || "")?.slice(0, 10)
                      : data?._chat?.lastMessage?.type === "MEDIA"
                        ? "Image"
                        : ""}
                  </p>
                )}
              </div>
              <p className="chat-time">
                {data?._chat?.lastMessage?.createdAt ? moment(data?._chat?.lastMessage?.createdAt).fromNow() : ''}
              </p>
            </div>
          ))}

        {/* Member Chat List */}
        {/* {selectedChatType === "MEMBER" && */}
        {chatType === "MEMBER" &&
          chatList && chatList.length > 0 ?
          chatList?.map((data, ind) => (
            <div
              key={ind}
              className="chat-item"
              onClick={() => {
                setSelectedChat(data?._chat);
                handleExit(data?._chat);
                handleMemberSearchData(data?._user?._id, data)
                setIsReplay(false)
                setSelectReplyData({})
                if (chatId) {
                  // navigate(`/dashboard/message`);
                  navigate('/dashboard/message/member')
                }
              }}
            >
              <div className="chat-avatar">
                <img
                  src={
                    data?._user?.profilePicture || data?._chat?.chatParticipants?._user?.profilePicture || avatar
                  }
                  alt="Mindful Movers"
                />
              </div>

              <div className="chat-details">
                <p className="chat-title">
                  {data?._user?.fullName || data?._chat?.chatParticipants?._user?.fullName}
                </p>
                {(data?._chat?.chatParticipants?.groupMember?.group?.name || data?._group?.name) && (
                  <p className="chat-subtitle">
                    Group: {data?._chat?.chatParticipants?.groupMember?.group?.name || data?._group?.name}
                  </p>
                )}

              </div>
              <p className="chat-time">
                {data?._chat?.lastMessage?.createdAt && moment(data?._chat?.lastMessage?.createdAt).fromNow()}
              </p>
            </div>
          )) : <p className="text-center mt-3">No Data Found</p>}
      </div>
    </div>
  );
};

export default ChatList;
